
import React from 'react';
import { NavLink } from 'react-router-dom';
import useFormContext from "./useFormContext.js";

export const Navigation = () => {
    const { handlepageChange } = useFormContext()

    return (
        <>
            <ul className="nav nav-custom flex-column">
                <li className="nav-item">
                    <NavLink onClick={(e) => { e.preventDefault(); handlepageChange(0); }}
                        className="nav-custom nav-link active"
                        aria-current="page"
                        href="#"
                    >
                        EVENT DETAILS
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink onClick={(e) => { e.preventDefault(); handlepageChange(1); }} className="nav-custom nav-link" href="#">
                        SCHEDULE &amp; ITINERARY
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink onClick={(e) => { e.preventDefault(); handlepageChange(2); }} className="nav-custom nav-link">
                        GUESTS
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink onClick={(e) => { e.preventDefault(); handlepageChange(3); }} className="nav-custom nav-link" href="#">
                        HISTORY &amp; COMMENTS
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink onClick={(e) => { e.preventDefault(); handlepageChange(4); }} className="nav-custom nav-link" href="#">
                        POST EVENT SUMMARY
                    </NavLink>
                </li>
            </ul>
        </>

    );
};
